import { trimByLength } from './trim-by-length';
const UTM_PARAMS_MAX_LENGTH = 32;
export const getUTMUrlProperties = () => {
  const result = [];
  if (!globalThis.location) {
    return null;
  }
  const searchParams = new URLSearchParams(globalThis.location.search);
  if (searchParams.size === 0) {
    return null;
  }
  searchParams.forEach((paramValue, paramName) => {
    if (paramValue) {
      /** Более короткая и человекочитаемая строка */
      const decodedValue = decodeURIComponent(paramValue);
      result.push({
        key: paramName,
        value: trimByLength(decodedValue)
      });
    }
  });
  if (result.length === 0) {
    return null;
  }
  return result.slice(0, UTM_PARAMS_MAX_LENGTH);
};